import React from 'react';

import { KeyNavigation } from 'shared/components/utils/KeyNavigation';

import { UnitOfTime } from './Time';

interface TimeNavigationProps {
  activeIndex: number;
  className?: string;
  onIndexChange: (index: number) => void;
  onArrowUpDown: (unit: UnitOfTime, direction: -1 | 1) => void;
  navigationKeys: string[];
}

export class TimeNavigation extends React.PureComponent<
  React.PropsWithChildren<TimeNavigationProps>,
  {}
> {
  getChildrenCount() {
    const { children } = this.props;
    return children ? React.Children.count(children) : 0;
  }

  onKeyDown(event: React.KeyboardEvent, unit: UnitOfTime) {
    const { activeIndex, onIndexChange, onArrowUpDown, navigationKeys } =
      this.props;
    const childrenCount = this.getChildrenCount();

    if (navigationKeys.includes(event.key) && activeIndex === -1) {
      onIndexChange(0);
      return;
    }

    switch (event.key) {
      case 'ArrowRight':
        event.preventDefault();
        onIndexChange(Math.min(activeIndex + 1, childrenCount - 1));
        break;
      case 'ArrowLeft':
        event.preventDefault();
        onIndexChange(Math.max(activeIndex - 1, 0));
        break;
      case 'ArrowDown':
        event.preventDefault();
        onArrowUpDown(unit, 1);
        event.stopPropagation();
        break;
      case 'ArrowUp':
        event.preventDefault();
        onArrowUpDown(unit, -1);
        event.stopPropagation();
        break;
      case 'Tab':
        onIndexChange(-1);
        event.stopPropagation();
        break;
    }
  }

  render() {
    const { activeIndex, className, onIndexChange, children } = this.props;
    return (
      <KeyNavigation
        activeIndex={activeIndex}
        className={className}
        onIndexChange={onIndexChange}
        onKeyDown={(e, unit) => this.onKeyDown(e, unit as UnitOfTime)}
      >
        {children}
      </KeyNavigation>
    );
  }
}
